module.exports = __webpack_public_path__ + "static/media/mash-bnb.5a7ce6be.png";